// extracted by mini-css-extract-plugin
export default {"PageContent":"PageContent_PageContent__qHRCj"};